import { LayoutState, ModalsType } from '../../models/layout'
import { LayoutActions } from '../actions/layout'

let defaultState: LayoutState = {
    showSidebar: true,
    showNavbar: true,
    showFabButton: true,
    showBackToTop: false,
    modals: {
        type: null,
        // type: ModalsType.NEW_ACTIVITY,
        props: { loading: false },
    },
    isApp: false,
    bottomFabButton: null,
    isChatbotOpen: false,
    breadcrumbs: [],
    breadcrumbNavigationProps: null,
    socialHubConfiguration: {
        showSocialHub: false,
        showAchievements: false,
        showBadges: false,
        showRecognitions: false,
        showChallenges: false,
        showRewardsCredits: false,
        showBirthday: false,
        showYearsOfEmployment: false,
        showUserRanking: false,
        showStoreRanking: false,
    },
}

export default (state = defaultState, action) => {
    switch (action.type) {
        case LayoutActions.SET_IS_APP:
            return {
                ...state,
                isApp: action.value,
            }
        case LayoutActions.SET_SHOW_SIDEBAR:
            return {
                ...state,
                showSidebar: action.value,
            }
        case LayoutActions.SET_SHOW_NAVBAR:
            return {
                ...state,
                showNavbar: action.value,
            }
        case LayoutActions.SET_SHOW_FAB_BUTTON:
            return {
                ...state,
                showFabButton: action.value,
            }
        case LayoutActions.SET_SHOW_BACK_TO_TOP:
            return {
                ...state,
                showBackToTop: action.value,
            }
        case LayoutActions.SET_MODALS:
            return {
                ...state,
                modals: {
                    ...state.modals,
                    ...action.value,
                    props: { ...state.modals.props, ...action.value.props },
                },
            }
        case LayoutActions.SET_BOTTOM_FAB_BUTTON:
            return {
                ...state,
                bottomFabButton: action.value,
            }
        case LayoutActions.SET_IS_CHATBOT_OPEN:
            return {
                ...state,
                isChatbotOpen: action.value,
            }
        case LayoutActions.PUSH_BREADCRUMB:
            return {
                ...state,
                breadcrumbs: [...state.breadcrumbs, ...action.breadcrumbs],
            }
        case LayoutActions.DELETE_BREADCRUMB:
            return {
                ...state,
                breadcrumbs: state.breadcrumbs.slice(
                    0,
                    action.index != null ? action.index + 1 : -1
                ),
            }
        case LayoutActions.RESET_BREADCRUMB:
            return {
                ...state,
                breadcrumbs: [],
            }
        case LayoutActions.SET_BREADCRUMB_NAVIGATION:
            return {
                ...state,
                breadcrumbNavigation: action.breadcrumbNavigation,
            }
        case LayoutActions.SET_SOCIAL_HUB_CONFIGURATION:
            return {
                ...state,
                socialHubConfiguration: {
                    ...state.socialHubConfiguration,
                    ...action.configuration,
                },
            }
        default:
            return state
    }
}
